<template>
    <modal @close="closeFromModal">
        <h5 slot="header">{{ $tl("questions.booking.services.removeFull", restaurant_id) }}</h5>
        <div slot="body">
            <remove-service-full
                ref="removeServiceFull"
                :restaurant_id="restaurant_id"
                :service_id="service_id"
                :slot_id="slot_id"
                :date="date"
                :showSaveButton="false" />
        </div>
        <div slot="footer" class="d-flex">
            <button class="modal-default-button btn btn-sm btn-secondary btn-circle" @click="$emit('close')">
                {{ $tl("labels.form.actions.cancel") }}
            </button>
            <button class="btn btn-success btn-sm btn-circle ms-2" @click="save">
                {{ $tl("labels.form.actions.save") }}
            </button>
        </div>
    </modal>
</template>

<script>
import RemoveServiceFull from "../../services/RemoveServiceFull";

export default {
    props: {
        restaurant_id: {
            default: "",
        },
        service_id: {
            default: "",
        },
        slot_id: {
            default: "",
        },
        date: {
            default: null,
        },
    },
    methods: {
        save() {
            this.$refs.removeServiceFull.setFormErrors(null);
            this.$refs.removeServiceFull.setFormLoading(true);
            const result = this.$refs.removeServiceFull.postForm(null);

            if (result !== false) {
                result
                    .then(() => {
                        this.$emit("closure-removed");
                    })
                    .catch((err) => {
                        if (err.response && err.response.data && err.response.data) {
                            this.$refs.removeServiceFull.setFormErrors(err.response.data);
                        } else if (err.message) {
                            this.$refs.removeServiceFull.setFormErrors({ message: err.message });
                        }
                        this.$refs.removeServiceFull.setFormLoading(false);
                    });
            } else {
                this.$refs.removeServiceFull.setFormLoading(false);
            }
        },
        close() {
            this.$emit("close");
        },
        closeFromModal: function (e) {
            if (e && e.target && !e.target.classList.contains("modal-wrapper")) {
                e.stopPropagation();
            } else {
                this.close();
            }
        },
    },
    components: {
        RemoveServiceFull,
    },
};
</script>
